<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <ProductListFiltersForm
      ref="product-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import ProductListFiltersForm from '@/components/products/form/ProductListFiltersForm.vue'
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'

export default {
  name: 'ProductListFilters',
  components: {
    BaseFiltersSideBar,
    ProductListFiltersForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['product-list-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>

<style lang="scss">
</style>
